import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check, Copy, X } from "lucide-react";

const CODE = "INICIO10";
const CREAM = "#F5F0E8";

export default function PromoBanner({ visible, onDismiss }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CODE);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // Clipboard API unavailable (older browsers, non-https). The code is
      // still visible in the banner so the user can copy it manually.
    }
  };

  return (
    <AnimatePresence initial={false}>
      {visible && (
        <motion.div
          data-testid="promo-banner"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="fixed top-0 inset-x-0 z-[60] bg-ink"
          style={{ color: CREAM, paddingTop: "env(safe-area-inset-top)" }}
        >
          <div className="max-w-[1400px] mx-auto px-4 md:px-12 py-1 md:py-2.5 flex items-center justify-center gap-2 sm:gap-3 text-[12px] sm:text-sm tracking-tight">
            <span className="opacity-95 text-center sm:text-left leading-snug">
              Garante já <span className="text-orange font-semibold">10% de desconto</span> com o código
            </span>
            <button
              onClick={copy}
              data-testid="promo-banner-code"
              aria-label={`Copiar código ${CODE}`}
              className="group inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full transition-colors duration-200"
              style={{
                border: `1px solid ${CREAM}55`,
                background: `${CREAM}0D`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = `${CREAM}B3`;
                e.currentTarget.style.background = `${CREAM}1A`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = `${CREAM}55`;
                e.currentTarget.style.background = `${CREAM}0D`;
              }}
            >
              <span className="font-mono font-semibold tracking-[0.18em] text-[12px] sm:text-[13px]">
                {CODE}
              </span>
              {copied ? (
                <Check size={13} className="text-orange" />
              ) : (
                <Copy size={13} style={{ opacity: 0.7 }} />
              )}
            </button>
            <button
              onClick={onDismiss}
              data-testid="promo-banner-close"
              aria-label="Fechar banner"
              className="ml-1 sm:ml-3 transition-opacity inline-flex items-center justify-center"
              style={{ opacity: 0.6, minWidth: 44, minHeight: 44 }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.6")}
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
